import React from "react";
import { useTranslate } from 'react-redux-multilingual'
import { ControlAccess} from '@gull'
import { Modal,Tabs, Tab} from "react-bootstrap";
import EditPriceForm from './EditPriceForm'
import CancelDiscount from './CancelDiscount'

/**
 * Modal d'édition du prix d'une ligne (remise %, remise nette, modification de prix, annulation de remise).
 * Partagée entre le POS et la facturation.
 *
 * @param {Array} prependTabs - Optionnel : onglets ajoutés avant les onglets de prix, [{ eventKey, title, content }]
 * @param {Array} appendTabs - Optionnel : onglets ajoutés après les onglets de prix, [{ eventKey, title, content }]
 * @param {boolean} hidePriceModification - Optionnel : masque l'onglet "Modification de prix" (ex. prix déjà éditable dans un onglet ajouté)
 */
const EditPriceModal = (props) =>{
    const t =useTranslate()
    const prependTabs = props.prependTabs || []
    const appendTabs = props.appendTabs || []
   
    return(
        <Modal size="md" show={props.showEditPrice} onHide={() => props.closeModal('price')}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {(props.restrictionModifPrix && !props.restrictionModifPrix.go) ? 
                    <ControlAccess section={props.section} restriction={props.restrictionModifPrix} setRestriction={props.setRestrictionModifPrix} moduleId={props.section.id} callback={props.callback} noMarge={true}/>
                :
                    <Tabs defaultActiveKey={prependTabs.length!==0 ? prependTabs[0].eventKey : "percent"} id="uncontrolled-tab-example" style={{marginTop:'1px'}}>
                        {prependTabs.map(tab=>
                            <Tab key={tab.eventKey} eventKey={tab.eventKey} title={tab.title}>{tab.content}</Tab>
                        )}
                        <Tab eventKey="percent" title={t('discountPercent')}>
                            <EditPriceForm 
                                module={props.module} 
                                isFor='percent' 
                                closeModal={props.closeModal}
                                cookies={props.cookies} 
                                item={props.item} 
                                setCurrentTicket={props.setCurrentTicket} 
                                setDisabledPay={props.setDisabledPay} 
                                itemsBilling={props.itemsBilling} 
                                setItemsBilling={props.setItemsBilling} 
                                setDatasPdf={props.setDatasPdf}
                                clientDetail={props.clientDetail} 
                                id={props.id}
                                setAllInfos={props.setAllInfos}
                                groupId={props.groupId}
                                forGroup={props.forGroup}
                                affichageClient={props.affichageClient}
                                peripheriqueParam={props.peripheriqueParam}
                                authParam={props.authParam}
                            />
                        </Tab>
                        <Tab eventKey="net" title={t('discountNet')}>
                            <EditPriceForm 
                                module={props.module} 
                                isFor='net' 
                                closeModal={props.closeModal} 
                                cookies={props.cookies} 
                                item={props.item} 
                                setCurrentTicket={props.setCurrentTicket} 
                                setDisabledPay={props.setDisabledPay} 
                                itemsBilling={props.itemsBilling} 
                                setItemsBilling={props.setItemsBilling} 
                                setDatasPdf={props.setDatasPdf}
                                clientDetail={props.clientDetail} 
                                id={props.id}
                                setAllInfos={props.setAllInfos}
                                groupId={props.groupId}
                                forGroup={props.forGroup}
                                affichageClient={props.affichageClient}
                                peripheriqueParam={props.peripheriqueParam}
                                authParam={props.authParam}
                            />
                        </Tab>
                        {!props.hidePriceModification &&
                        <Tab eventKey="modif" title={t('priceModification')}>
                            <EditPriceForm 
                                module={props.module} 
                                isFor='modif' 
                                closeModal={props.closeModal} 
                                cookies={props.cookies} 
                                item={props.item} 
                                setCurrentTicket={props.setCurrentTicket} 
                                setDisabledPay={props.setDisabledPay} 
                                itemsBilling={props.itemsBilling} 
                                setItemsBilling={props.setItemsBilling} 
                                setDatasPdf={props.setDatasPdf}
                                clientDetail={props.clientDetail} 
                                id={props.id}
                                setAllInfos={props.setAllInfos}
                                groupId={props.groupId}
                                forGroup={props.forGroup}
                                affichageClient={props.affichageClient}
                                peripheriqueParam={props.peripheriqueParam}
                                authParam={props.authParam}
                            />
                        </Tab>
                        }
                        {((props.item && (props.item.remise!=0 || props.item.remise_type=='prixfixe') && props.item.promotion_id==null) || props.forGroup) &&
                            <Tab eventKey="cancel" title={t('cancelDiscount')}>
                                <CancelDiscount
                                    id={props.id}
                                    cookies={props.cookies}
                                    item={props.item}
                                    closeModal={props.closeModal}
                                    setCurrentTicket={props.setCurrentTicket} 
                                    setItemsBilling={props.setItemsBilling}  
                                    setDatasPdf={props.setDatasPdf}
                                    setAllInfos={props.setAllInfos}
                                    groupId={props.groupId}
                                    forGroup={props.forGroup}
                                    affichageClient={props.affichageClient}
                                    peripheriqueParam={props.peripheriqueParam}
                                    module={props.module}
                                />
                            </Tab>
                        }
                        {appendTabs.map(tab=>
                            <Tab key={tab.eventKey} eventKey={tab.eventKey} title={tab.title}>{tab.content}</Tab>
                        )}
                    </Tabs>
                }
            </Modal.Body>
        </Modal>
    )
}

export default EditPriceModal;